
import { signOut } from 'firebase/auth';
import { auth } from '../firebase'
import { deleteCookie } from '../helper';

function userLogout() {
    deleteCookie('user');
    signOut(auth);
}

export {
    userLogout
}